import { Link } from "react-router-dom";
import Layout from "../components/layout/Layout";
import useSeo from "../hooks/useSeo";
import { ChevronRight, Award, Users, Clock, Shield } from "lucide-react";

const VALUES = [
  { icon: Award, title: "Uzman Danışmanlık", text: "15+ yıllık sektör deneyimiyle her otel projesine özel çözüm." },
  { icon: Users, title: "Kurumsal Ekip", text: "Yıldız standartları, mevzuat ve tedarik konusunda uzmanlaşmış ekip." },
  { icon: Clock, title: "Hızlı Yanıt", text: "Teklif taleplerine 24 saat içinde profesyonel dönüş." },
  { icon: Shield, title: "Uzun Vadeli Ortaklık", text: "Açılış sonrası da yanınızda — sürekli tedarik anlaşmaları." },
];

export default function About() {
  useSeo({ title: "Hakkımızda — Otel Pro", description: "Otel açılışında uzman danışmanlık ve premium B2B tedarik." });
  return (
    <Layout>
      <div className="bg-softbg">
        <div className="container-site py-5 flex items-center gap-2 text-xs text-gray-500">
          <Link to="/" className="hover:text-navy">Ana Sayfa</Link>
          <ChevronRight size={12} />
          <span className="text-navy font-medium">Hakkımızda</span>
        </div>
      </div>

      <section className="bg-navy text-white py-20">
        <div className="container-site max-w-3xl">
          <p className="accent-script text-gold text-2xl mb-2">Hikâyemiz</p>
          <h1 className="heading-serif text-3xl md:text-5xl font-semibold leading-tight">
            Otel açılışlarında<br />
            <span className="text-gold">uzman partneriniz.</span>
          </h1>
        </div>
      </section>

      <section className="section-pad">
        <div className="container-site max-w-4xl grid md:grid-cols-2 gap-10 items-start">
          <div>
            <h2 className="heading-serif text-2xl font-semibold text-navy mb-4">Kim Olduğumuzu Biliyoruz</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Otel Pro, Türkiye'de otel ekipman tedarikçisinden daha fazlasıdır — açılış danışmanınızdır. Yeni açılışlarda,
              renovasyon projelerinde ve yıldız yükseltme süreçlerinde 15+ yıllık deneyimimizle yanınızdayız.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Sadece satmıyoruz; mevzuatı, standartları ve konuk beklentilerini en iyi şekilde bilen bir ekip olarak
              otelinizin başarısını kendi işimiz gibi sahipleniyoruz.
            </p>
          </div>
          <div>
            <img src="https://images.pexels.com/photos/6466496/pexels-photo-6466496.jpeg?auto=compress&cs=tinysrgb&w=1200" alt="Otel Pro" className="rounded-xl w-full object-cover aspect-[4/5]" />
          </div>
        </div>
      </section>

      <section className="section-pad bg-softbg">
        <div className="container-site max-w-5xl">
          <h2 className="heading-serif text-2xl md:text-3xl font-semibold text-navy text-center mb-10">Değerlerimiz</h2>
          <div className="grid md:grid-cols-4 gap-5">
            {VALUES.map((v, i) => (
              <div key={v.title} className="card-premium p-6 text-center" data-testid={`about-value-${i}`}>
                <div className="h-12 w-12 mx-auto rounded-full bg-gold/10 text-gold flex items-center justify-center mb-4">
                  <v.icon size={20} />
                </div>
                <h3 className="heading-serif text-lg font-semibold text-navy mb-2">{v.title}</h3>
                <p className="text-xs text-gray-600 leading-relaxed">{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}
